import React from "react";
import "./Button.css";

interface ButtonProps {
  text: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: "submit" | "reset" | "button";
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = ({ text, onClick, type, loading }) => {
  return (
    <button
      className="custom-button"
      onClick={onClick}
      type={type}
      disabled={loading}
    >
      {text}
    </button>
  );
};

export default Button;
